import { Box, Button, Grid } from '@chakra-ui/react';

import InfoLabel from '@/components/InfoLabel';
import Tip from '@/components/Tip/Tip';
import IEventType from '@/types/IEventType';
import { IEventTypeWrite } from '@/types/apiClient/IEventTypeWrite';
import AddParticipantModal from './components/add-participant-modal/add-participant.modal';
import ParticipantItem from './components/participant-item/participant-item.view';
import { useRequiredParticipants } from './required-participants.controller';

interface IProps {
	eventType: IEventType;
	onChange: (values: Partial<IEventTypeWrite>) => void;
	onEditAvailabilityClick: (id: string) => void;
}

export default function RequiredParticipants(props: IProps) {
	const { t, isLoading, disclosure, handleAddRequiredParticipantClick } = useRequiredParticipants(props);

	return (
		<Box pb={4}>
			<Grid gridTemplateColumns="1fr auto" alignItems="center">
				<InfoLabel
					text={t('Mandatory attendees')}
					help={t('The booking calendar will have free slots when this people are available')}
				/>
			</Grid>

			{!props.eventType.resourceRules?.linkedResources?.length ? (
				<Box my={4}>
					<Tip>
						{t(
							'Add the availabilities of the people you require to attend the meeting mandatorily. The booking calendar will show slots only when ALL participants are available.'
						)}
					</Tip>
				</Box>
			) : null}

			<Grid gap={2} w="full">
				{props.eventType.resourceRules?.linkedResources?.map((resource) => {
					return (
						<ParticipantItem
							onEditAvailabilityClick={props.onEditAvailabilityClick}
							isLoading={isLoading}
							key={resource.id}
							eventType={props.eventType}
							resourceId={resource.id}
						/>
					);
				})}
			</Grid>

			<Button mt={4} colorScheme="primary" w="full" size="sm" onClick={handleAddRequiredParticipantClick}>
				{t('Add attendee')}
			</Button>

			<AddParticipantModal eventType={props.eventType} isOpen={disclosure.isOpen} close={disclosure.onClose} />
		</Box>
	);
}
